import { render, staticRenderFns } from "./channel-list.vue?vue&type=template&id=3ca1971a&scoped=true&"
import script from "./channel-list.vue?vue&type=script&lang=js&"
export * from "./channel-list.vue?vue&type=script&lang=js&"
import style0 from "./channel-list.vue?vue&type=style&index=0&id=3ca1971a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca1971a",
  null
  
)

export default component.exports